module.exports = __webpack_public_path__ + "static/media/pc-01.8950e1ba.svg";